import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import loadImage from 'common/utils/loadImage';

const IMAGE_BLANK = 0;
const IMAGE_LOADED = 2;

class LazyLoadedImage extends PureComponent {
    static propTypes = {
        url: PropTypes.string.isRequired,
        shouldLoad: PropTypes.bool,
    };

    static defaultProps = {
        shouldLoad: true,
    };

    state = {
        imageLoadingStatus: IMAGE_BLANK,
    };

    componentDidMount() {
        if (this.props.shouldLoad) {
            this.loadImage();
        }
    }

    UNSAFE_componentWillUpdate(nextProps) {
        if (nextProps.shouldLoad && !this.props.shouldload) {
            this.loadImage();
        }
    }

    loadImage() {
        loadImage(this.props.url)
            .then(() => {
                this.setState({ imageLoadingStatus: IMAGE_LOADED });
            })
            .catch(() => {
                this.setState({ imageLoadingStatus: IMAGE_LOADED });
            });
    }

    renderImage() {
        return <img src={this.props.url} />;
    }

    renderPlaceholder() {
        return (
            <div style={{ visibility: 'hidden' }}>
                <div style={{ paddingBottom: '100%' }} />
            </div>
        );
    }

    render() {
        return this.state.imageLoadingStatus === IMAGE_LOADED
            ? this.renderImage()
            : this.renderPlaceholder();
    }
}

export default LazyLoadedImage;
